import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {PrenotazioneAppuntamentoService} from "../../services/prenotazione-appuntamento.service";
import {UserData} from "../../models/user-data";
import {FormBuilder, FormGroup} from "@angular/forms";
import {MessageService} from "../../services/message.service";
import {AppuntamentoPage} from "../../models/appuntamento";
import {Servizio} from "../../models/servizio";
import {AppuntamentiService} from "../../services/appuntamenti.service";
import {SubscriptionManager} from "../../shared/subscription-manager/subscription-manager.class";
import {AlertService} from "../../shared/alert/alert.service";
import {format, isBefore, parse} from "date-fns";
import {zonedTimeToUtc} from "date-fns-tz";
import { CD_SERVIZIO_SALE } from '../../app.constants';
import { ConfigurazioneGeneraleService } from '../../services/configurazione-generale.service';

@Component({
  selector: 'jhi-gestione-appuntamenti-admin',
  templateUrl: './lista-prenotazioni.component.html',
  styleUrls: ['./lista-prenotazioni.component.scss']
})
export class ListaPrenotazioniComponent extends SubscriptionManager implements OnInit {
  user: UserData | null = JSON.parse(localStorage.getItem('userData') ?? '{}');
  loading = false;
  appuntamenti: AppuntamentoPage[] = [];
  paginaCorrente = 0;
  servizi!: Servizio[];
  ordinamentoData: string;
  disabilitaForm = this.fb.group({
    content: this.fb.group({
      id: this.fb.control<number | null>(null),
      stato: ''
    })
  });
  pageForm: FormGroup = this.fb.group({
    numEle: [10].toString(),
    currentPage: [this.paginaCorrente.toString()],
    idDichiarante: [this.user?.id],
  });
  pageFormFiltro: FormGroup = this.fb.group({
    numEle: [10].toString(),
    currentPage: [this.paginaCorrente.toString()],
    idDichiarante: [this.user?.id],
    stato: '',
    servizio: '',
    dataInizio: '',
    dataFine: '',
    ordinamento: ''
  })
  Isfirst!: string;
  Islast!: string;
  Totalpages!: number;
  Totalelement!: string;

  constructor(public route: Router, public appServ: PrenotazioneAppuntamentoService, private fb: FormBuilder, private messageService: MessageService, private apiserviceAppuntamento: AppuntamentiService, private alertService: AlertService, private confService: ConfigurazioneGeneraleService) {
    super();
    this.ordinamentoData = "desc";
  }

  ngOnInit(): void {
    this.loading = true;
    this.getAppuntamentiPage();
    this.subs.sink = this.pageForm.controls['numEle'].valueChanges
      .subscribe(
        {
          next: () => {
            this.getAppuntamentiPage();
          },
        })
  }

  formPatchValue(idAppuntamento: number | undefined | null): void {
    this.disabilitaForm.patchValue({
      content: {
        id: idAppuntamento
      }
    })
  }

  pulisciFiltri(): void {
    this.loading = true;
    this.pageFormFiltro = this.fb.group({
      numEle: [10].toString(),
      currentPage: [this.paginaCorrente.toString()],
      idDichiarante: [this.user?.id],
      stato: '',
      servizio: '',
      dataInizio: '',
      dataFine: '',
      ordinamento: ''
    })
    this.getAppuntamentiPage()
  }

  goToNuovoAppuntamento(): void {
    this.route.navigate(['Appuntamenti/inserimento-dati-prenotazione'], {state: {previousRoute: 'Appuntamenti/lista-prenotazioni'}}).then();
    this.appServ.callerPage = this.route.url;
  }

  goToHome():void{
    window.location.href = this.confService.configurazione.linkHome;
  }

  annullaAppuntamento(): void {
    this.loading = true;
    this.subs.sink = this.appServ.modificaAppuntamento((this.disabilitaForm.value).content?.id)
      .subscribe({
        error: (err) => {
          let msg = ''
          if(err.error.messaggio){
            msg = err.error.messaggio;
          }else if(err.error.status === 401){
            msg = "Utente non autenticato o sessione scaduta";
          }else{
            msg = "Errore nell'annullamento di un appuntamento con stato: " + String(err.error.status);
          }
          this.alertService.creaAlert(msg, "danger", "sticky", 4000, true)
          this.loading = false
        },
        complete: () => {
          this.alertService.creaAlert("Appuntamento annullato con successo", "success", "sticky", 5000, true)
          this.subs.sink = this.appServ.listaAppuntamentiPaginazione(this.pageForm.controls['numEle'].value,this.paginaCorrente, this.ordinamentoData).subscribe({
            next: (res) => {
              this.appuntamenti = <AppuntamentoPage[]>res.body;
              },
            complete: () => {
              this.loading = false;
            },
            error: (err) => {
              this.loading = false;
              let msg = ''
              if(err.error.messaggio){
                msg = err.error.messaggio;
              }else if(err.error.status === 401){
                msg = "Utente non autenticato o sessione scaduta";
              }else{
                msg = "Errore nel caricamento trasferimento di un appuntamento con stato: " + String(err.error.status);
              }
              this.alertService.creaAlert(msg, "danger", "sticky", 4000, true)
            },
          });
        }
      })
  }

  paginaPrecedente(): void {
    this.paginaCorrente--;
    this.pageForm.patchValue({
      currentPage: this.paginaCorrente.toString()
    })
    this.getAppuntamentiPage();
  }

  paginaSuccessiva(): void {
    this.paginaCorrente++;
    this.pageForm.patchValue({
      currentPage: this.paginaCorrente.toString()
    })
    this.getAppuntamentiPage();
  }

  getAppuntamentiPage(): void {
    this.loading = true;
    const filtri = {
      inizio: this.pageFormFiltro.controls['dataInizio'].value,
      fine: this.pageFormFiltro.controls['dataFine'].value,
      stato: this.pageFormFiltro.controls['stato'].value,
      idServizio: this.pageFormFiltro.controls['servizio'].value,
    }
    if(isBefore(zonedTimeToUtc(parse(this.pageFormFiltro.controls['dataFine'].value, "yyyy-MM-dd", new Date()), 'Europe/Rome'),zonedTimeToUtc(parse(this.pageFormFiltro.controls['dataInizio'].value, "yyyy-MM-dd", new Date()), 'Europe/Rome') )){
      this.alertService.creaAlert("La data di fine non può essere prima della data di inizio", "warning","sticky",5000,true);
      this.loading = false;
    }else{
      this.subs.sink = this.appServ.listaAppuntamentiPaginazione(this.pageForm.controls['numEle'].value,this.paginaCorrente, this.ordinamentoData, filtri).subscribe({
        next: (res) => {
          this.appuntamenti = <AppuntamentoPage[]>res.body;
          this.Isfirst = <string>res.headers.get('Isfirst');
          this.Islast = <string>res.headers.get('Islast');
          this.Totalpages = Number(res.headers.get('Totalpages'));
          this.Totalelement = <string>res.headers.get('Totalelement');
          if(res.status === 204){
            this.appuntamenti = [];
          }
        },
        complete: () => {
          this.subs.sink = this.apiserviceAppuntamento.ricercaTuttiServiziApi().subscribe({
            next: (ser: Servizio[]) => {
              this.servizi = ser;
            },
          });
          this.loading = false;
        },
        error: (err) => {
          this.alertService.creaAlert(err.error.messaggio, "danger", "sticky",5000,true);
        },
      });
    }
  }

  vaiAPagina(index: number): void {
    this.paginaCorrente = index;
    this.pageForm.patchValue({
      currentPage: this.paginaCorrente.toString()
    })
    this.getAppuntamentiPage();
  }

  sendAppointment(appuntamento: AppuntamentoPage): void {
    this.messageService.sendSingleAppointmentInterface(appuntamento);
    this.route.navigate(['Appuntamenti/dettaglio-appuntamento']).then();
  }

  changeStatoOrdinamento(): void {
    if (this.ordinamentoData === "desc") {
      this.ordinamentoData = "asc";
    } else {
      this.ordinamentoData = "desc";
    }
    this.pageFormFiltro.patchValue({
      ordinamento: this.ordinamentoData
    });
    this.getAppuntamentiPage();
  }

  goBack(): void {
    if (window.history.state.previousRoute) {
      void this.route.navigate([window.history.state.previousRoute])
    } else {
      void this.route.navigate(['Cruscotto/le-mie-attivita']);
    }
  }

  formatTime(inputTime: string | undefined): string {
    const inputDate = new Date(`1970-01-01T${<string>inputTime}`);
    return format(inputDate, 'HH:mm');
  }

  protected readonly CD_SERVIZIO_SALE = CD_SERVIZIO_SALE;
}
